import styled from 'styled-components'

interface SelectProps {
  bordercolor: string
  backgroundcolor: string
  outlinecolor?: string
}

interface LabelProps {
  fontSize?: string
  color?: string
}

interface ContainerProps {
  flex?: string
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: ${(props) => (props.flex ? props.flex : '1')};
`

export const Content = styled.div<SelectProps>`
  overflow: hidden;
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 0.25rem;
  border: 1px solid #cecece;
  background-color: #f7f7f7;
  transition: 0.1s;
  outline: none;
  cursor: text;

  &:focus-within {
    outline: 1px solid
      ${(props) =>
        props.outlinecolor
          ? props.outlinecolor
          : props.theme.color.neutral.gray};
  }
`

interface InputProps {
  padding?: string
}

export const Input = styled.select<InputProps>`
  width: 100%;
  height: 100%;
  padding: ${(props) => (props.padding ? props.padding : '0.625rem 0.875rem')};
  border: none;
  outline: none;
  background: inherit;
  color: #494949;
`

export const Label = styled.label<LabelProps>`
  font-size: ${(props) =>
    props.fontSize ? props.fontSize : props.theme.font.textcaption};
  color: ${(props) =>
    props.color ? props.color : props.theme.color.neutral.gray};
`
